import React from 'react'
import { PersonCheckFill } from 'react-bootstrap-icons'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import hooks from '../../../hooks'

const AbsentIndicator = ({
    course = {},
    size = 20,
    userId,
}) => {
    const { id } = hooks.useCurrentUser()

    if (!course.attended) {
        return null
    }

    return (
        <OverlayTrigger
            trigger={['click', 'hover']}
            placement='auto'
            rootClose
            overlay={
                <Popover>
                    <Popover.Content >
                        <strong>{userId === id ? 'You' : 'They'} were marked present for this experience.</strong>
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                style={{
                    color: 'rgb( 35, 200, 51 )',
                    cursor: 'pointer',
                }}
            >
                <PersonCheckFill size={size} />
            </div>
        </OverlayTrigger>
    )
}

export default AbsentIndicator